<template>
    <div class="white-label-modal-mask">
        <div class="white-label-modal-container">
            <div class="white-label-modal-header">
                {{ titleModal }}
                <span
                    @click="close"
                    class="material-icons white-label-modal-close"
                    >cancel</span
                >
            </div>

            <div class="white-label-modal-body" v-if="loading">
                <cc-loader class="white-label-modal-loader" />
            </div>

            <div class="white-label-modal-body" v-else>
                <form @submit.prevent="save" class="white-label-modal-form">
                    <div class="formContent">
                        <div class="divInputsContent">
                            <!-- Cor primária -->
                            <div
                                class="white-label-modal-form-group color-group"
                            >
                                <div>
                                    <label
                                        for="primary_color"
                                        class="color-label"
                                        >Escolha a cor</label
                                    >
                                    <div class="color-input-container">
                                        <span
                                            for="primary_color"
                                            class="color-label"
                                            style="white-space: nowrap;"
                                        >
                                            Cor primária
                                        </span>
                                        <input
                                            class="inputColor"
                                            id="primary_color"
                                            type="color"
                                            v-model="form.primary_color"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>

                            <!-- Logo -->
                            <div
                                class="white-label-modal-form-group logo-group"
                            >
                                <label for="img_logo">Logo</label>
                                <div class="logo-input-wrapper">
                                    <!-- Ícone customizado para upload -->
                                    <label for="img_logo" class="custom-upload">
                                        <span class="material-icons"
                                            >upload</span
                                        >
                                        <span class="upload-text">Upload</span>
                                    </label>

                                    <input
                                        id="img_logo"
                                        type="file"
                                        accept="image/*"
                                        @change="
                                            e => handleFileUpload(e, 'logo')
                                        "
                                        style="display: none"
                                        required
                                    />

                                    <!-- Preview da imagem -->
                                    <div
                                        v-if="previewLogoUrl"
                                        class="logo-preview"
                                    >
                                        <img
                                            :src="previewLogoUrl"
                                            alt="Preview da Logo"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div
                                class="white-label-modal-form-group logo-group"
                            >
                                <label for="img_background"
                                    >Imagem de background</label
                                >
                                <div class="logo-input-wrapper">
                                    <!-- Ícone customizado para upload -->
                                    <label
                                        for="img_background"
                                        class="custom-upload"
                                    >
                                        <span class="material-icons"
                                            >upload</span
                                        >
                                        <span class="upload-text">Upload</span>
                                    </label>

                                    <input
                                        id="img_background"
                                        type="file"
                                        accept="image/*"
                                        @change="
                                            e =>
                                                handleFileUpload(
                                                    e,
                                                    'background'
                                                )
                                        "
                                        style="display: none"
                                        required
                                    />
                                    <!-- Preview da imagem -->
                                    <div
                                        v-if="previewBackgroundUrl"
                                        class="logo-preview"
                                    >
                                        <img
                                            :src="previewBackgroundUrl"
                                            alt="Preview do Background"
                                        />
                                    </div>
                                </div>
                            </div>

                            <!-- URL -->
                            <div class="white-label-modal-form-group ">
                                <StandardInput
                                    type="text"
                                    required
                                    :value="form.url"
                                    :action="val => (form.url = val)"
                                    :placeholder="'ex:jml.clubdacotacao.com'"
                                    :title="'URL'"
                                    :auto="true"
                                />
                            </div>
                        </div>

                        <white-label-preview
                            :primaryColor="form.primary_color"
                            :logoUrl="previewLogoUrl || logoFornecedor"
                            :logoUrlLogin="previewLogoUrl || logoOrange"
                            :backgroundUrl="
                                previewBackgroundUrl || imgBackground
                            "
                        />
                    </div>

                    <!-- Ações -->
                    <div class="white-label-modal-actions">
                        <StandardButton
                            class="white-label-modal-button"
                            :action="close"
                            text="Cancelar"
                        />
                        <StandardButton
                            class="white-label-modal-button"
                            :action="save"
                            text="Salvar"
                        />
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import StandardButton from "@/components/ui/buttons/StandardButton.vue";
import ResaleService from "@/services/v3/resales/resale.service";
import StandardInput from "@/components/ui/inputs/StandardInputV2.vue";
import whiteLabelPreview from "./white-label-preview.vue";

import logoFornecedor from "../../assets/logoFornecedor.png";
import logoOrange from "../../assets/logotipo.1f5fe5ad.png";
import imgBackground from "../../assets/NewAdminBackground.jpg";

export default {
    mixins: [loaderMixin],
    props: {
        id: Number,
        titleModal: String
    },
    components: {
        StandardButton,
        StandardInput,
        whiteLabelPreview
    },
    computed: {
        logoFornecedor() {
            return logoFornecedor;
        },
        logoOrange() {
            return logoOrange;
        },
        imgBackground() {
            return imgBackground;
        }
    },

    data() {
        return {
            loading: false,
            form: {
                primary_color: "#ff7010",
                url: "",
                img_logo: null,
                img_background: null
            },
            previewLogoUrl: null,
            previewBackgroundUrl: null,
            svc: new ResaleService()
        };
    },
    methods: {
        close() {
            this.$emit("close");
        },

        handleFileUpload(event, type) {
            const file = event.target.files[0];
            if (!file) return;

            if (type === "logo") {
                this.form.img_logo = file;
                this.previewLogoUrl = URL.createObjectURL(file);
            } else if (type === "background") {
                this.form.img_background = file;
                this.previewBackgroundUrl = URL.createObjectURL(file);
            }
        },
        async save() {
            this.loading = true;
            const body = new FormData();
            body.append("img_logo", this.form.img_logo);
            body.append("img_background", this.form.img_background);
            body.append("primary_color", this.form.primary_color);
            body.append(
                "for_domain_whitelabel",
                this.form.url?.trim() ? this.form.url.trim() : "null"
            );

            try {
                await this.svc.whiteLabelCreate(body);
                const notification = {
                    type: "success",
                    message: `White Label configurado com sucesso!`
                };
                this.$store.dispatch("notification/add", notification);
                this.close();
                this.$emit("saved");
            } catch (err) {
                const notification = {
                    type: "error",
                    message: `Erro ao salvar White Label, tente novamente mais tarde!`
                };
                this.$store.dispatch("notification/add", notification);

                console.error("Erro ao salvar white label", err);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.white-label-modal-mask {
    position: fixed;
    z-index: 1000;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1vw;
}

.white-label-modal-container {
    width: 85vw;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    overflow: hidden;
}

.white-label-modal-header {
    background-color: var(--primary-color);
    padding: 1rem;
    color: white;
    font-size: 1.5em;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.white-label-modal-close {
    cursor: pointer;
    font-size: 1.2em;
}

.white-label-modal-body {
    padding: 2rem;
    height: 89vh;
    overflow-y: auto;
}

.white-label-modal-form-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    width: 100%;
    min-width: 330px;
}

.white-label-modal-form-group label {
    font-size: 1.5em;
    letter-spacing: 0.15px;
    color: #6e6e6e;
}

.formContent {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    // align-items: center;
    gap: 2rem;
}

.color-group {
    display: flex;
    /* align-items: center; */
    justify-content: flex-start;
    gap: 1rem;
}

.color-label {
    font-weight: 500;
}

.color-input-container {
    border: 1px solid #ddd;
    padding: 6px;
    border-radius: 12px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    max-width: 200px;
    color: #8f8f8fc8;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
    cursor: pointer;
}

.inputColor {
    width: 60px;
    height: 40px;
    /* border-radius: 10px; */
    border: none;
    padding: 0;
    cursor: pointer;
    appearance: none;
    background: none;
}

.custom-upload {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    transition: border-color 0.3s;
    color: #6e6e6e;
    gap: 0.5rem;
}

.custom-upload:hover {
    border-color: #999;
}

.logo-input-wrapper {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.logo-preview img {
    max-width: 60px;
    border-radius: 6px;
    border: 1px solid #ccc;
}

.white-label-modal-form input[type="text"],
.white-label-modal-form input[type="file"] {
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 6px;
}

.white-label-modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 1.5rem;
    margin-top: 3rem;
}

.white-label-modal-button {
    min-width: 120px;
}

.white-label-modal-loader {
    margin-top: 10vh;
}

@media (max-width: 950px) {
    .white-label-modal-mask {
        font-size: 0.8em;
    }

    .white-label-modal-container {
        width: 100vw;
        height: 100vh;
        border-radius: 0;
    }
}
@media (max-width: 900px) {
    .formContent {
        flex-direction: column;
        gap: 1rem;
    }
    .divInputsContent {
        display: flex;
        flex-direction: row;
        gap: 1rem;
        flex-wrap: wrap;
    }
}
@media only screen and (max-width: 500px) {
    .white-label-modal-container {
        width: 115vw;
    }
}
</style>
